import { LoadingSpinner, ScrollArea } from '@app/shared/ui/atoms/Common';
import {
  DailyBannersSection,
  CarouselSection,
  StonesBanner,
  DevelopSection,
} from '@app/shared/ui/organisms/Cognition';
import { usePreloadImages } from '@app/shared/hooks/usePreloadImages';
import { COGNITION_PRELOAD_IMAGES } from '@app/assets';

export default function CognitionPage() {
  const isImagesLoading = usePreloadImages(COGNITION_PRELOAD_IMAGES);

  if (isImagesLoading) return <LoadingSpinner />;

  return (
    <ScrollArea className="space-y-3">
      <CarouselSection />
      <StonesBanner />
      <DailyBannersSection />
      <DevelopSection />
    </ScrollArea>
  );
}
